import Button from 'devextreme-react/button';
import {
  TimeOffCalendarOrgFilter,
  type TimeOffCalendarOrgFilter as CalendarOrgFilter
} from './TimeOffCalendarOrgFilter';
import { TimeOffCalendarEmployeeFilter, type CalendarEmployeeFilterValue } from './TimeOffCalendarEmployeeFilter';
import type { TimeOffOrgOptions } from '../../../../api/timeOff';

interface TimeOffCalendarToolbarFiltersProps {
  employeeFilter: CalendarEmployeeFilterValue | null;
  onEmployeeFilterChange: (value: CalendarEmployeeFilterValue | null) => void;
  orgFilter: CalendarOrgFilter;
  onOrgFilterChange: (value: CalendarOrgFilter) => void;
  orgOptions: TimeOffOrgOptions;
  orgOptionsLoading?: boolean;
  onReset: () => void;
  /** Full-width stacked layout for narrow viewports (in-page, not shell toolbar). */
  stacked?: boolean;
  /** Compact mobile panel: placeholder labels, employee + org row layout. */
  mobilePanel?: boolean;
}

export function TimeOffCalendarToolbarFilters({
  employeeFilter,
  onEmployeeFilterChange,
  orgFilter,
  onOrgFilterChange,
  orgOptions,
  orgOptionsLoading,
  onReset,
  stacked = false,
  mobilePanel = false
}: TimeOffCalendarToolbarFiltersProps) {
  const hasActiveFilters = employeeFilter !== null || orgFilter.kind !== 'all';
  const compact = !stacked || mobilePanel;
  const orgFilterControl = (
    <TimeOffCalendarOrgFilter
      compact={compact}
      options={orgOptions}
      value={orgFilter}
      onChange={onOrgFilterChange}
      loading={orgOptionsLoading}
    />
  );

  return (
    <div
      className={`time-off-toolbar-filters${stacked ? ' time-off-toolbar-filters--stacked' : ''}${mobilePanel ? ' time-off-toolbar-filters--mobile-panel' : ''}`}
    >
      <TimeOffCalendarEmployeeFilter compact={compact} value={employeeFilter} onChange={onEmployeeFilterChange} />
      {mobilePanel ? (
        <div className="time-off-toolbar-filters__org-row">{orgFilterControl}</div>
      ) : (
        orgFilterControl
      )}
      <Button
        className="time-off-toolbar-filters__reset"
        text="Reset"
        icon="refresh"
        stylingMode="text"
        hint="Clear employee, company, and department filters"
        disabled={!hasActiveFilters}
        onClick={onReset}
      />
    </div>
  );
}
